import {useEffect,useMemo,useState} from "react";
import {Box,Container,Typography} from "@mui/material";
import {useAppTheme} from "../../context/ThemeContext";
import icon1 from "../../static/Home/icon1.webp";
import icon2 from "../../static/Home/icon2.webp";
import icon3 from "../../static/Home/icon3.webp";

export default function FootballValuesSection(){
  const {colors,shape}=useAppTheme();

  const items=useMemo(()=>[
    {
      image:icon1,
      alt:"Juego limpio",
      text:"Juega limpio y respeta cada decisión."
    },
    {
      image:icon2,
      alt:"Trabajo en equipo",
      text:"El equipo siempre está por encima del ego."
    },
    {
      image:icon3,
      alt:"Disciplina",
      text:"La disciplina sostiene cada gran victoria."
    }
  ],[]);

  const [activeIndex,setActiveIndex]=useState(0);
  const [visible,setVisible]=useState(true);

  useEffect(()=>{
    const interval=setInterval(()=>{
      setVisible(false);

      setTimeout(()=>{
        setActiveIndex(prev=>(prev+1)%items.length);
        setVisible(true);
      },300);
    },5000);

    return()=>clearInterval(interval);
  },[items.length]);

  const activeItem=items[activeIndex];

  const itemBoxSx={
    display:"flex",
    alignItems:"center",
    gap:1.25,
    minWidth:0,
    px:{xs:1.5,sm:2},
    py:{xs:1.5,sm:1.8},
    border:`1px solid ${colors.border}`,
    borderRadius:shape.radiusLarge,
    backgroundColor:colors.surface
  };

  return(
    <Box
      component="section"
      aria-label="Valores del fútbol"
      sx={{
        width:"100%",
        backgroundColor:colors.surface,
        py:{xs:4.5,sm:5.5,md:6.5}
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          px:{xs:2.5,sm:4,md:5,lg:7}
        }}
      >
        <Box
          sx={{
            display:{xs:"none",md:"grid"},
            gridTemplateColumns:"repeat(3,minmax(0,1fr))",
            gap:2
          }}
        >
          {items.map((item,index)=>(
            <Box
              key={index}
              sx={itemBoxSx}
            >
              <Box
                sx={{
                  width:{md:58,lg:64},
                  height:{md:58,lg:64},
                  flexShrink:0,
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center"
                }}
              >
                <Box
                  component="img"
                  src={item.image}
                  alt={item.alt}
                  sx={{
                    width:"100%",
                    height:"100%",
                    objectFit:"contain"
                  }}
                />
              </Box>

              <Typography
                sx={{
                  minWidth:0,
                  fontSize:{md:13,lg:14},
                  fontWeight:400,
                  lineHeight:1.6,
                  color:colors.text
                }}
              >
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            display:{xs:"flex",md:"none"},
            justifyContent:"center"
          }}
        >
          <Box
            sx={{
              ...itemBoxSx,
              width:"100%",
              maxWidth:460,
              opacity:visible?1:0,
              transform:visible?"translateY(0)":"translateY(6px)",
              transition:"opacity .3s ease, transform .3s ease"
            }}
          >
            <Box
              sx={{
                width:58,
                height:58,
                flexShrink:0,
                display:"flex",
                alignItems:"center",
                justifyContent:"center"
              }}
            >
              <Box
                component="img"
                src={activeItem.image}
                alt={activeItem.alt}
                sx={{
                  width:"100%",
                  height:"100%",
                  objectFit:"contain"
                }}
              />
            </Box>

            <Typography
              sx={{
                minWidth:0,
                fontSize:13.5,
                fontWeight:400,
                lineHeight:1.6,
                color:colors.text
              }}
            >
              {activeItem.text}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}